module.exports = __webpack_public_path__ + "img/produkte.24b1d43c.svg";